import { render, staticRenderFns } from "./Houseinfo.vue?vue&type=template&id=4e2a7122&scoped=true&"
import script from "./Houseinfo.vue?vue&type=script&lang=js&"
export * from "./Houseinfo.vue?vue&type=script&lang=js&"
import style0 from "./Houseinfo.vue?vue&type=style&index=0&id=4e2a7122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a7122",
  null
  
)

export default component.exports